import {Component, HostListener} from '@angular/core';
import {KeyLogService} from '../../../services/key-log.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'key-log-list',
    templateUrl: './key-log-list.component.html',
    styleUrls: ['./key-log-list.component.scss']
})
export class KeyLogListComponent {

    constructor(
        public urlService: UrlService,
        public keyLogService: KeyLogService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.keyLogService.data.allKeyLogs.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    signOutKey(keyLog) {
        this.keyLogService.signOutKey(keyLog);
    }

    returnKey(keyLog) {
        this.keyLogService.returnKey(keyLog);
        keyLog.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-list/key-log-list.component.ts